import { render, staticRenderFns } from "./Reglamento.vue?vue&type=template&id=136b9f4e"
import script from "./Reglamento.vue?vue&type=script&lang=js"
export * from "./Reglamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports